import type { Admin, RbacV2RolePermission } from '@gozoki/api-types'
import type { Right } from '@gozoki/tools'
import { createContext } from 'react'

export interface AuthContextType {
  authenticated: boolean
  user: Admin | null
  refetchUser: () => Promise<unknown>
  isLoading: boolean
  logout: () => Promise<void>
  /** Bitmask legacy `adminRights` — seule garde effective tant que `permission-v2` est OFF. */
  hasRights: (rights: Right[]) => boolean
  hasOneRight: (rights: Right[]) => boolean
  rbacLoading: boolean
  /**
   * Flag `permission-v2` du contrat retenu par `resolveRbacSession` — la même source que l'ability
   * installée. Exposé ici pour que `useRbacV2Enabled` ne puisse pas en diverger (MAJ-01).
   */
  rbacV2Enabled: boolean
  /** Grants v2 réels du même contrat, quel que soit `permission-v2` (`NavLink.grantsV2Predicate`). */
  rbacGrantsV2: RbacV2RolePermission[]
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  hasRights: () => false,
  hasOneRight: () => false,
  isLoading: false,
  rbacLoading: false,
  rbacV2Enabled: false,
  rbacGrantsV2: [],
  logout: async () => {},
  refetchUser: async () => {},
  user: null,
})
